import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormControl,
  MenuItem,
  Grid,
  FormControlLabel,
  Checkbox,
  Button,
  makeStyles,
  Typography,
  Box,
  Switch,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Save } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import Select from "react-select";
import { useForm } from "../../../hooks/useForm";
import { CboProvincias } from "../../cbos/CboProvincias";
import { CboLocalidades } from "../../cbos/CboLocalidades";
import {
  contratacionesGuardarContrato,
  fetchMatriculasMedicas,
  fetchMotivosBaja,
  fetchNomenclador,
} from "../../../actions/contrataciones/contrataciones";
import { fetchSubTipoEfectores } from "../../../actions/tipoSubtipoEfectores";
import { fetchEspecialidades } from "../../../actions/especialidades";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import { startAlerta } from "../../../actions/ui/alertas";
import {
  SUBTIPO_EFECTORES,
  MENU_CONTRATACIONES,
  TIPO_EFECTORES,
  NOMENCLADORES,
  SUB_AREAS_CONTRATACIONES,
} from "../../../utils/constants";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { CONTRATACIONES_INFORMACION_PERMISOS } from "../../../utils/permisos";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  hideButton: {
    display: "none",
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
  addButtonField: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  addButton: {
    marginLeft: 10,
  },
  switchBase: {
    color: '#bdbdbd',
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#4CAF50',
      '& + $track': {
        backgroundColor: '#3E8040',
        opacity: 1,
        border: 'none',
      },
    },
  },
  checked: {},
  track: {},
}));

export const InfoContrataciones = memo((props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  moment.locale("es");

  const { dataContrato, permisos } = props;

  const { presupuesto } = useSelector((state) => state.contrataciones);
  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );
  const { items } = useSelector((state) => state.localidades);
  const { nomencladores, matriculasMedicas, motivosBaja } = useSelector((state) => state.contrataciones);
  const especialidades = useSelector((state) => state.especialidades);
  const motivosBajaEfector = useSelector(state => state.motivosBajaEfector);

  const { items: cobraCoseguro } = useSelector((state) => state.cobraCoseguro);
  const { permisos: permisosUser, subAreasContrataciones } = useSelector((state) => state.auth);

  const especialidadesOptions = especialidades.items.map(item => ({
    value: item.idEspecialidades,
    label: item.descripcionEspecialidades,
  }))

  const valoresIniciales = {
    ...dataContrato,
    validaPortalPrestador: false,
    validaAutorizacion: true,
    idSubTipoEfector: presupuesto ? SUBTIPO_EFECTORES.EVENTUAL : '',
    idTipoNomenclador: presupuesto ? NOMENCLADORES.NOMENCLADOR_OSPEDYC : ''
  }

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
    setearVariosValoresHijos,
  ] = useForm(props.nuevo ? valoresIniciales : dataContrato);

  const {
    idTipoEfector,
    idSubTipoEfector,
    cuit,
    razonSocial,
    nombreFantasia,
    fechaInicioCarga,
    fechaInicioVigencia,
    // fechaFinVigencia,
    redNacional,
    idTipoNomenclador,
    efectorDomicilio,
    efectorMatriculas,
    efectorFacturacionEspecialidades,
    nroPolizaSeguro,
    fechaInicioSeguro,
    fechaFinSeguro,
    rnp,
    fechaFinRnp,
    cufe,
    idMotivoBaja,
    fechaBaja,
    apremio,
    capita,
    idCobraCoseguro,
    validaPortalPrestador,
    validaAutorizacion
  } = formValues;

  // CONDICIONALES
  const showRedNacional =
    idSubTipoEfector === SUBTIPO_EFECTORES.PERSONAS_JURIDICAS ||
    idSubTipoEfector ===
    SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES;

  const showCapita =
    idSubTipoEfector === SUBTIPO_EFECTORES.PERSONAS_JURIDICAS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_ESTABLECIMIENTOS_REDES_GERENCIADORAS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.ENTIDADES_INTERMEDIAS_PROFESIONALES ||
    idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA ||
    idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_AJENOS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.PERSONAS_JURIDICAS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.HOSPITAL;

  const showApremio = idSubTipoEfector === SUBTIPO_EFECTORES.HOSPITAL;

  const matriculaObligatoria =
    idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_AJENOS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ||
    idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA ||
    dataContrato.idTipoEfector === TIPO_EFECTORES.INTEGRACION;

  const especialidadesObligatoria = idSubTipoEfector !== SUBTIPO_EFECTORES.FARMACIA &&
    dataContrato.idTipoEfector !== TIPO_EFECTORES.INTEGRACION &&
    idSubTipoEfector !== SUBTIPO_EFECTORES.EVENTUAL &&
    idSubTipoEfector !== SUBTIPO_EFECTORES.ENFERMERIA &&
    idSubTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR &&
    idSubTipoEfector !== SUBTIPO_EFECTORES.COMPRAS_MEDICAS 
    ;

  // const rnpObligatorio = idTipoEfector !== TIPO_EFECTORES.INTEGRACION
  //   ;

  useEffect(() => {
    //FECHA FIN VIGENCIA
    ValidatorForm.addValidationRule("isBeforeFechaInicioVigencia", (value) => {
      if (
        moment(value).isValid() &&
        moment(value).isBefore(moment(fechaInicioVigencia))
      ) {
        return false;
      }
      return true;
    });

    //FECHA BAJA
    ValidatorForm.addValidationRule("isBeforeFechaCarga", (value) => {
      if (
        moment(value).isValid() &&
        moment(value).isBefore(moment(fechaInicioCarga))
      ) {
        return false;
      }
      return true;
    });
  });

  const handleLocalidadChange = (e) => {
    if (items.length > 0) {
      const localidad = items.find(
        (loc) => parseInt(loc.id_localidad) === parseInt(e.target.value)
      );
      setearVariosValoresHijos("efectorDomicilio", {
        idLocalidad: localidad?.id_localidad,
        idProvincia: localidad?.id_provincia,
      });
    }
  };

  const eventMulti = (e) => {
    setearValor(
      "efectorFacturacionEspecialidades",
      e.map((e) => e.value)
    );
  };

  const handleSelectAllEspecialidades = (e) => {
    if (e.target.checked) {
      setearValor("efectorFacturacionEspecialidades", especialidadesOptions.map(item => item.value));
    } else {
      setearValor("efectorFacturacionEspecialidades", []);
    }
  }
  // SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();
    let auxMatriculas = [];
    // Validar si hay al menos una matricula para los subtipo de efectores
    if (matriculaObligatoria) {
      // eslint-disable-next-line
      matriculasMedicas.map((item) => {
        if (
          e.target.elements[`matricula-tipo-${item.idTipoMatricula}`].value !==
          ""
        ) {
          auxMatriculas.push({
            idMatricula: efectorMatriculas.find(
              (m) => m.idTipoMatricula === item.idTipoMatricula
            )?.idMatricula,
            idTipoMatricula: item.idTipoMatricula,
            numero:
              e.target.elements[`matricula-tipo-${item.idTipoMatricula}`].value,
          });
        }
      });

      if (auxMatriculas.length === 0) {
        dispatch(
          startAlerta("Debe seleccionar al menos una matricula", "error")
        );
        return;
      }
    }
    // Validar si hay al menos una especialidad para los subtipo de efectores
    if (
      especialidadesObligatoria &&
      efectorFacturacionEspecialidades.length === 0
    ) {
      dispatch(
        startAlerta("Debe seleccionar al menos una especialidad", "error")
      );
      return;
    }

    dispatch(
      contratacionesGuardarContrato({
        ...formValues,
        efectorMatriculas: auxMatriculas,
      }, props.setNuevo)
    );
  };

  useEffect(() => {
    dispatch(fetchSubTipoEfectores(idTipoEfector));

    if (nomencladores?.length === 0) {
      dispatch(fetchNomenclador());
    }
    if (matriculasMedicas?.length === 0) {
      dispatch(fetchMatriculasMedicas());
    }
    if (motivosBaja?.length === 0) {
      dispatch(fetchMotivosBaja());
    }
    dispatch(fetchEspecialidades(true));
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (!matriculaObligatoria) {
      setearVariosValores({
        efectorMatriculas: [],
      });
    }
    // eslint-disable-next-line
  }, [matriculaObligatoria]);

  useEffect(() => {
    if (!especialidadesObligatoria) {
      setearVariosValores({
        efectorFacturacionEspecialidades: [],
      });
    }
    // eslint-disable-next-line
  }, [especialidadesObligatoria]);

  useEffect(() => {
    if (!showRedNacional) {
      setearVariosValores({
        redNacional: false,
      });
    }
    // eslint-disable-next-line
  }, [showRedNacional]);

  useEffect(() => {
    if (dataContrato?.idEfectorFacturacion !== formValues.idEfectorFacturacion) {
      setearVariosValores(dataContrato);
    }
    // eslint-disable-next-line

    props.setSubTipoEfector(dataContrato?.idSubTipoEfector)

  }, [dataContrato]);

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <SelectValidator
              fullWidth
              margin="normal"
              name="idSubTipoEfector"
              label="Subtipo de Efector"
              defaultValue={idSubTipoEfector}
              value={idSubTipoEfector}
              //onChange={handleInputChange}
              onChange={(e) => {
                (setearVariosValores({
                  idSubTipoEfector: e.target.value,
                  idTipoNomenclador: (e.target.value === SUBTIPO_EFECTORES.PROVEEDOR || idSubTipoEfector !== SUBTIPO_EFECTORES.COMPRAS_MEDICAS ? NOMENCLADORES.SIN_DENOMINACION : idTipoNomenclador)
              }))
              props.setSubTipoEfector(e.target.value)
              }}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              validators={["required"]}
              errorMessages={["Seleccione un tipo de prestador"]}
            >
              {
                subtipoEfectores.filter(e => {
                  if (subAreasContrataciones.find((subArea) => subArea.idSubArea === SUB_AREAS_CONTRATACIONES.RRHH)) {
                    return (e.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS || e.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA)
                  } else {
                    if (permisos.tieneEnfermeriaOCmp) {
                      return (e.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS || e.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA)
                    } else {
                      return (e.idSubTipoEfector !== SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS && e.idSubTipoEfector !== SUBTIPO_EFECTORES.ENFERMERIA)
                    }
                  }
                }).map((item) => (
                  <MenuItem
                    key={item.idSubTipoEfector}
                    value={item.idSubTipoEfector}
                  >
                    {item.descripcionSubTipoEfector}
                  </MenuItem>
                ))}
            </SelectValidator>
          </Grid>
          {dataContrato?.idEfectorFacturacion !== null && (
            <Grid item sm={1}>
              <TextValidator
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
                fullWidth={true}
                label="Cód. Contrato"
                name="codigoContrato"
                value={formValues.idEfectorFacturacion}
                autoComplete="off"
                maxLength="13"
                disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              />
            </Grid>
          )}
          <Grid item sm={2}>
            <TextValidator
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
              fullWidth={true}
              label="CUIT"
              name="cuit"
              value={cuit || ""}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
            />
          </Grid>
          <Grid item sm={3}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              label="Razón Social"
              name="razonSocial"
              value={razonSocial || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              validators={["required"]}
              errorMessages={["La Razon Social es requerida"]}
            />
          </Grid>
          <Grid item sm={dataContrato?.idEfectorFacturacion !== null ? 3 : 4}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              label="Nombre (Fantasia)"
              name="nombreFantasia"
              value={nombreFantasia || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              validators={["required"]}
              errorMessages={["El nombre de fantasia es requerido"]}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              autoComplete="off"
              label="Calle"
              name="efectorDomicilio.calle"
              value={efectorDomicilio?.calle || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              validators={["required"]}
              errorMessages={["La calle es requerida"]}
            />
          </Grid>
          <Grid item sm={1}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              autoComplete="off"
              label="Número"
              name="efectorDomicilio.nro"
              value={efectorDomicilio?.nro || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              validators={["required"]}
              errorMessages={["La altura es requerida"]}
            />
          </Grid>
          <Grid item sm={1}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              autoComplete="off"
              label="Piso"
              name="efectorDomicilio.piso"
              value={efectorDomicilio?.piso || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
            />
          </Grid>
          <Grid item sm={1}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              autoComplete="off"
              label="Depto."
              name="efectorDomicilio.depto"
              value={efectorDomicilio?.depto || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
            />
          </Grid>
          <Grid item sm={1}>
            <TextValidator
              margin="normal"
              fullWidth={true}
              autoComplete="off"
              label="CP"
              name="efectorDomicilio.cp"
              value={efectorDomicilio?.cp || ""}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
            />
          </Grid>
          <Grid item sm={2}>
            <CboLocalidades
              cp={efectorDomicilio?.cp ? efectorDomicilio?.cp : 0}
              valor={efectorDomicilio?.idLocalidad}
              name="idLocalidad"
              manejadorInputChange={handleLocalidadChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
            />
          </Grid>
          <Grid item sm={2}>
            <CboProvincias
              name="idProvincia"
              valor={efectorDomicilio?.idProvincia}
              manejadorInputChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {showRedNacional && (
            <Grid item sm={1} style={{ alignSelf: 'center' }}>
              <FormControl
                className={classes.formControl}
                fullWidth={true}
                margin="normal"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="redNacional"
                      checked={redNacional}
                      onChange={(e) => setearValor("redNacional", !redNacional)}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    />
                  }
                  label="Red"
                />
              </FormControl>
            </Grid>
          )}
          {showApremio && (
            <Grid item sm={2} style={{ alignSelf: 'center' }}>
              <FormControl
                className={classes.formControl}
                fullWidth={true}
                margin="normal"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="apremio"
                      checked={apremio}
                      onChange={(e) => setearValor("apremio", !apremio)}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    />
                  }
                  label="Apremio"
                />
              </FormControl>
            </Grid>
          )}
          <Grid item sm={2}>
            <SelectValidator
              fullWidth
              margin="normal"
              name="idTipoNomenclador"
              label="Nomenclador"
              value={idTipoNomenclador}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA || idSubTipoEfector === SUBTIPO_EFECTORES.PROVEEDOR  || idSubTipoEfector === SUBTIPO_EFECTORES.COMPRAS_MEDICAS}
              validators={["required"]}
              errorMessages={["Seleccione un tipo de nomenclador"]}
              InputLabelProps={{
                shrink: idTipoNomenclador !== null,
              }}
            >
              {nomencladores.map((item) => (
                <MenuItem key={item.idNomenclador} value={item.idNomenclador}>
                  {item.descripcion}
                </MenuItem>
              ))}
            </SelectValidator>
          </Grid>
          <Grid item sm={2}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                fullWidth={true}
                margin="normal"
                label="Fecha de Carga"
                format="dd/MM/yyyy"
                maxDate={moment(new Date()).add(3, "M")}
                okLabel="Aceptar"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                name="fechaInicioCarga"
                disabled={idSubTipoEfector !== SUBTIPO_EFECTORES.EVENTUAL}
                onChange={(e) => setearValor("fechaInicioCarga", e)}
                value={
                  moment(fechaInicioCarga).isValid()
                    ? moment(fechaInicioCarga)
                    : new Date()
                }
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          {
            idSubTipoEfector !== SUBTIPO_EFECTORES.EVENTUAL &&
            <Grid item sm={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  label={"Fecha Inicio Vigencia"}
                  format="dd/MM/yyyy"
                  maxDate={moment(new Date()).add(3, "M")}
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  name="fechaInicioVigencia"
                  onChange={(e) => setearValor("fechaInicioVigencia", e)}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  value={
                    moment(fechaInicioVigencia).isValid()
                      ? moment(fechaInicioVigencia)
                      : null
                  }
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={["required"]}
                  errorMessages={["La fecha de inicio de vigencia es requerida"]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          }
          {/* {idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL &&
            <Grid item sm={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  label="Fecha Fin Vigencia"
                  format="dd/MM/yyyy"
                  maxDate={moment(new Date()).add(3, "Y")}
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  name="fechaFinVigencia"
                  value={
                    moment(fechaFinVigencia).isValid()
                      ? moment(fechaFinVigencia)
                      : null
                  }
                  onChange={(e) => setearValor("fechaFinVigencia", e)}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={["isBeforeFechaInicioVigencia"]}
                  errorMessages={[
                    "La fecha debe ser posterior a la fecha de inicio vigencia.",
                  ]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          } */}
          {
            (dataContrato.idEfectorFacturacion && idSubTipoEfector !== SUBTIPO_EFECTORES.EVENTUAL) &&
            <>
              <Grid item sm={2}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <ValidatedDatePicker
                    fullWidth={true}
                    margin="normal"
                    label="Fecha Baja"
                    format="dd/MM/yyyy"
                    maxDate={moment(new Date()).add(3, "Y")}
                    okLabel="Aceptar"
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    name="fechaBaja"
                    value={
                      moment(fechaBaja).isValid()
                        ? moment(fechaBaja)
                        : null
                    }
                    onChange={(e) => setearValor("fechaBaja", e)}
                    disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    validators={idMotivoBaja !== null ? ["required", "isBeforeFechaCarga"] : []}
                    errorMessages={idMotivoBaja !== null ? [
                      "La fecha de baja es requerida",
                      "La fecha debe ser posterior o igual a la fecha de carga.",
                    ] : []}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item sm={2}>
                <SelectValidator
                  fullWidth
                  margin="normal"
                  name="idMotivoBaja"
                  label="Motivos de baja"
                  value={idMotivoBaja || ""}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={moment(fechaBaja).isValid() ? ["required"] : []}
                  errorMessages={moment(fechaBaja).isValid() ? ["Seleccione un motivo de baja"] : []}
                >
                  <MenuItem value={null}><em>Seleccione...</em></MenuItem>
                  {motivosBajaEfector.items.map((item) => (
                    <MenuItem
                      key={item.idMotivoBaja}
                      value={item.idMotivoBaja}
                    >
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>
            </>
          }

          {
            showCapita &&
            <Grid item sm={1} style={{ alignSelf: 'center' }}>
              <FormControl
                className={classes.formControl}
                fullWidth={true}
                margin="normal"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="capita"
                      checked={capita}
                      onChange={(e) => setearValor("capita", !capita)}
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    />
                  }
                  label="Cápita"
                />
              </FormControl>
            </Grid>
          }
        </Grid>
        {
          (validarSoloUnPermiso(permisosUser, CONTRATACIONES_INFORMACION_PERMISOS.ADMINISTRAR) && idSubTipoEfector !== SUBTIPO_EFECTORES.EVENTUAL && idSubTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR  && idSubTipoEfector !== SUBTIPO_EFECTORES.COMPRAS_MEDICAS) &&
          <Grid container spacing={1}>
            {
              (idSubTipoEfector !== SUBTIPO_EFECTORES.NO_RECUPERABLES &&
                idSubTipoEfector !== SUBTIPO_EFECTORES.ADICCION
              ) &&
              <>
                <Grid item sm={2}>
                  <TextValidator
                    margin="normal"
                    fullWidth={true}
                    autoComplete="off"
                    label="RNP"
                    name="rnp"
                    value={rnp || ""}
                    onChange={handleInputChange}
                    disabled={props.menuLegales === MENU_CONTRATACIONES.CONSULTA || (props.tieneSubAreaLegales && props.nuevo) }
                  // validators={["required"]}
                  // errorMessages={[
                  //   "El RNP es requerido"
                  // ]}
                  />
                </Grid>
                <Grid item sm={2}>
                  <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                    <ValidatedDatePicker
                      fullWidth={true}
                      margin="normal"
                      label="Fecha Fin RNP"
                      format="dd/MM/yyyy"
                      maxDate={moment(new Date()).add(3, "Y")}
                      okLabel="Aceptar"
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      name="fechaFinRnp"
                      value={
                        moment(fechaFinRnp).isValid() ? moment(fechaFinRnp) : null
                      }
                      onChange={(e) => setearValor("fechaFinRnp", e)}
                      disabled={props.menuLegales === MENU_CONTRATACIONES.CONSULTA || (props.tieneSubAreaLegales && props.nuevo)}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    // validators={rnpObligatorio ? ["required"] : []}
                    // errorMessages={rnpObligatorio ? ["La fecha fin RNP es requerida"] : []}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </>
            }
            <Grid item sm={2}>
              <TextValidator
                margin="normal"
                fullWidth={true}
                autoComplete="off"
                label="Nro Póliza"
                name="nroPolizaSeguro"
                value={nroPolizaSeguro || ""}
                onChange={handleInputChange}
                disabled={props.menuLegales === MENU_CONTRATACIONES.CONSULTA || (props.tieneSubAreaLegales && props.nuevo)}
              // validators={["required"]}
              // errorMessages={[
              //   "El nro de poliza es requerido"
              // ]}
              />
            </Grid>
            <Grid item sm={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  label="Fecha Inicio Póliza"
                  format="dd/MM/yyyy"
                  maxDate={moment(new Date()).add(3, "Y")}
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  name="fechaInicioSeguro"
                  value={
                    moment(fechaInicioSeguro).isValid()
                      ? moment(fechaInicioSeguro)
                      : null
                  }
                  onChange={(e) => setearValor("fechaInicioSeguro", e)}
                  disabled={props.menuLegales === MENU_CONTRATACIONES.CONSULTA || (props.tieneSubAreaLegales && props.nuevo)}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                // validators={["required"]}
                // errorMessages={["La fecha inicio póliza es requerida"]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item sm={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  label="Fecha Fin Póliza"
                  format="dd/MM/yyyy"
                  maxDate={moment(new Date()).add(3, "Y")}
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  name="fechaFinSeguro"
                  value={
                    moment(fechaFinSeguro).isValid()
                      ? moment(fechaFinSeguro)
                      : null
                  }
                  onChange={(e) => setearValor("fechaFinSeguro", e)}
                  disabled={props.menuLegales === MENU_CONTRATACIONES.CONSULTA || (props.tieneSubAreaLegales && props.nuevo)}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                // validators={["required"]}
                // errorMessages={["La fecha de fin de la póliza es requerida"]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            {idSubTipoEfector === SUBTIPO_EFECTORES.FARMACIA && (
              <Grid item sm={2}>
                <TextValidator
                  margin="normal"
                  fullWidth={true}
                  autoComplete="off"
                  label="CUFE"
                  name="cufe"
                  value={cufe || ""}
                  onChange={handleInputChange}
                  disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                  validators={[
                    "required",
                    "isNumber",
                    "minNumber:999999999999",
                    "maxNumber:9999999999999",
                  ]}
                  errorMessages={[
                    "El cufe es requerido",
                    "El valor debe ser numerico",
                    "Debe tener 13 digitos",
                    "Debe tener 13 digitos",
                  ]}
                />
              </Grid>
            )}
          </Grid>
        }

        <Grid container spacing={4} style={{ marginTop: "1rem" }}>
          {matriculaObligatoria && (
            <Grid item sm={4}>
              <Typography variant="button">Matrículas Médicas</Typography>
              {matriculasMedicas.map((item) => (
                <Grid
                  container
                  spacing={2}
                  justify="flex-end"
                  alignItems="flex-end"
                  key={item.descripcion}
                >
                  <Grid item xs={5}>
                    <Typography>{item.descripcion}</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <TextValidator
                      id="standard-basic"
                      label="Núm. Matrícula"
                      variant="standard"
                      name={`matricula-tipo-${item.idTipoMatricula}`}
                      defaultValue={
                        efectorMatriculas.find(
                          (matricula) =>
                            matricula.idTipoMatricula === item.idTipoMatricula
                        )?.numero || ""
                      }
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                      validators={["isNumber", "maxNumber:999999"]}
                      errorMessages={["Sólo números", "Verifique el código"]}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>
          )}
          {especialidadesObligatoria && (
            <Grid item sm={4}>
              <Typography variant="button">Especialidades</Typography>
              <Select
                onChange={eventMulti}
                isDisabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                value={
                  efectorFacturacionEspecialidades?.map((item) => {
                    const especialidad = especialidades.items.find(
                      (e) => e.idEspecialidades === item
                    );
                    return especialidad
                      ? {
                        value: especialidad.idEspecialidades,
                        label: especialidad.descripcionEspecialidades,
                      }
                      : undefined;
                  }) ?? []
                }
                isMulti
                name="colors"
                options={especialidadesOptions}
                placeholder="Seleccione Especialidades..."
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPosition="fixed"
              />
              {
                props.menu !== MENU_CONTRATACIONES.CONSULTA &&
                <div style={{ display: "flex", alignItems: "center", marginTop: 7 }}>
                  <input type="checkbox" onChange={handleSelectAllEspecialidades} style={{ margin: 0, marginRight: 3 }} />
                  <span style={{ fontSize: "0.75rem" }}>Seleccionar todas</span>
                </div>
              }
            </Grid>
          )}
          {/* {idSubTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR && <Grid item sm={4}>
                <Box display='flex' justifyContent='left' alignItems='center'> 
                  <Typography variant="button">Aplica Coseguro</Typography>
                  <FormControlLabel style={{ marginLeft: 5 }} control={
                    <Switch 
                      name="cobraCoseguro"
                      checked={idSubTipoEfector === SUBTIPO_EFECTORES.PROVEEDOR ? false : cobraCoseguro}
                      onChange={(e) => {setearValor(e.target.name, e.target.checked)}}
                      color="primary"
                      disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                      classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                    />}
                  />
                </Box>
          </Grid>} */}
          {(idSubTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR || idSubTipoEfector !== SUBTIPO_EFECTORES.COMPRAS_MEDICAS)  && <Grid item sm={2}>
            <SelectValidator
              fullWidth
              margin="normal"
              name="idCobraCoseguro"
              label="Cobra Coseguro"
              value={idCobraCoseguro}
              onChange={handleInputChange}
              disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
              validators={["required"]}
              errorMessages={["Seleccione un valor de coseguro"]}
              InputLabelProps={{
                shrink: idCobraCoseguro !== null,
              }}
            >
              {cobraCoseguro.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.descripcion}
                </MenuItem>
              ))}
            </SelectValidator>
          </Grid>}
          {idSubTipoEfector !== SUBTIPO_EFECTORES.PROVEEDOR && idSubTipoEfector !== SUBTIPO_EFECTORES.COMPRAS_MEDICAS &&

            <Grid item sm={4}>
              <Box display='flex' justifyContent='left' alignItems='center'>
                <Typography variant="button">Valida Portal Prestador</Typography>
                <FormControlLabel style={{ marginLeft: 5 }} control={
                  <Switch
                    name="validaPortalPrestador"
                    checked={validaPortalPrestador}
                    onChange={(e) => { setearValor(e.target.name, e.target.checked) }}
                    color="primary"
                    disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                  />}
                />
              </Box>
              <Box display='flex' justifyContent='left' alignItems='center'>
                <Typography variant="button">Valida Autorizacion</Typography>
                <FormControlLabel style={{ marginLeft: 5 }} control={
                  <Switch
                    name="validaAutorizacion"
                    checked={validaAutorizacion}
                    onChange={(e) => { setearValor(e.target.name, e.target.checked) }}
                    color="primary"
                    disabled={props.menu === MENU_CONTRATACIONES.CONSULTA}
                    classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                  />}
                />
              </Box>
            </Grid>
          }
        </Grid>
        {
          props.menu !== MENU_CONTRATACIONES.CONSULTA &&
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              color="primary"
              variant="contained"
              startIcon={<Save />}
              style={{ marginTop: "1rem" }}
              type="submit"
            >
              Guardar Cambios
            </Button>
          </div>
        }
      </ValidatorForm>
    </React.Fragment >
  );
});
